// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3bl-Y","left":"StickyBox_left__2sBre","right":"StickyBox_right__2mBn3"};